import styles from "./BenefitsSection.module.css";

const FirstSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path d="M15.9993 29.3332C23.3631 29.3332 29.3327 23.3636 29.3327 15.9998C29.3327 8.63604 23.3631 2.6665 15.9993 2.6665C8.63555 2.6665 2.66602 8.63604 2.66602 15.9998C2.66602 23.3636 8.63555 29.3332 15.9993 29.3332Z" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M12 15.9999L14.6667 18.6666L20 13.3333" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
)

const SecondSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path d="M15.999 9V29" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M3.39902 24.6667C3.02772 24.6667 2.67162 24.5145 2.40907 24.2436C2.14652 23.9727 1.99902 23.6053 1.99902 23.2222V4.44444C1.99902 4.06135 2.14652 3.69395 2.40907 3.42307C2.67162 3.15218 3.02772 3 3.39902 3H10.399C11.8842 3 13.3086 3.60873 14.3588 4.69227C15.409 5.77582 15.999 7.24542 15.999 8.77778C15.999 7.24542 16.589 5.77582 17.6392 4.69227C18.6894 3.60873 20.1138 3 21.599 3H28.599C28.9703 3 29.3264 3.15218 29.589 3.42307C29.8515 3.69395 29.999 4.06135 29.999 4.44444V23.2222C29.999 23.6053 29.8515 23.9727 29.589 24.2436C29.3264 24.5145 28.9703 24.6667 28.599 24.6667H20.199C19.0851 24.6667 18.0168 25.1232 17.2292 25.9359C16.4415 26.7485 15.999 27.8507 15.999 29C15.999 27.8507 15.5565 26.7485 14.7689 25.9359C13.9812 25.1232 12.9129 24.6667 11.799 24.6667H3.39902Z" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
)

const ThirdSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="31" viewBox="0 0 25 31" fill="none">
    <path d="M15.25 1.5H4.25C3.52065 1.5 2.82118 1.795 2.30546 2.3201C1.78973 2.8452 1.5 3.55739 1.5 4.3V26.7C1.5 27.4426 1.78973 28.1548 2.30546 28.6799C2.82118 29.205 3.52065 29.5 4.25 29.5H20.75C21.4793 29.5 22.1788 29.205 22.6945 28.6799C23.2103 28.1548 23.5 27.4426 23.5 26.7V9.9L15.25 1.5Z" stroke="white" stroke-width="3"/>
    <path d="M15.3182 1.5V9.9H23.5M8.5 16.9H16.6818M8.5 22.5H16.6818" stroke="white" stroke-width="3"/>
  </svg>
)

const FourthSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <path d="M25.3327 18.6667C27.3193 16.72 29.3327 14.3867 29.3327 11.3333C29.3327 9.38841 28.5601 7.52315 27.1848 6.14788C25.8095 4.77262 23.9443 4 21.9993 4C19.6527 4 17.9993 4.66667 15.9993 6.66667C13.9993 4.66667 12.346 4 9.99935 4C8.05443 4 6.18917 4.77262 4.8139 6.14788C3.43863 7.52315 2.66602 9.38841 2.66602 11.3333C2.66602 14.4 4.66602 16.7333 6.66602 18.6667L15.9993 28L25.3327 18.6667Z" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
)

interface Benefit {
  readonly title: string;
  readonly description: string;
  readonly gradientClass: string;
  readonly icon: any;
}

const BENEFITS: Benefit[] = [
  {
    title: "Чёткий пошаговый план",
    icon: <FirstSvg />,
    description: "Понятная программа занятий на каждый день без перегруза",
    gradientClass: "iconGreen",
  },
  {
    title: "Игры с речевыми фразами",
    icon: <SecondSvg />,
    description: "Готовые фразы и игры, которые легко повторять с ребёнком",
    gradientClass: "iconBlue",
  },
  {
    title: "Результаты занятий",
    icon: <ThirdSvg />,
    description: "Отслеживайте прогресс и появление новых слов",
    gradientClass: "iconPurple",
  },
  {
    title: "Поддержка и уверенность",
    icon: <FourthSvg />,
    description: "Обратная связь и спокойствие на каждом этапе занятий",
    gradientClass: "iconPink",
  },
];

export const BenefitsSection = () => {
  return (
    <section className={styles.section} aria-label="Что вы получите">
      <div className={styles.container}>
        <h2 className={styles.title}>
          Что вы получите{" "}
          <span className={styles.emoji} aria-hidden="true">⭐</span>
        </h2>

        <div className={styles.grid}>
          {BENEFITS.map((benefit) => (
            <div key={benefit.title} className={styles.item}>
              <div className={`${styles.iconWrap} ${styles[benefit.gradientClass]}`}>
                {benefit.icon}
              </div>
              <h3 className={styles.itemTitle}>{benefit.title}</h3>
              <p className={styles.itemDesc}>{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};